import { useState } from "react";
import { toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";

import useAddCoordinatorMutation from "../../hooks/useAddCoordinatorMutation";
import { showApiErrorToast } from "../../utils/helpers";

const AddCrcModal = ({ investigator, trialId, roleType, roleLabel, onClose }) => {
  const [crc, setCrc] = useState({ first_name: "", last_name: "", email: "" });
  const addCoordinatorMutation = useAddCoordinatorMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCrc((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    addCoordinatorMutation.mutate(
      {
        ...crc,
        head_user: investigator.id,
        trials: [trialId],
        typeOfStaff: roleType,
      },
      {
        onSuccess: () => {
          toast.success(`${roleLabel} added successfully`);
          onClose();
        },
        onError: (err) => showApiErrorToast(err),
      }
    );
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Add {roleLabel} for {investigator.label}
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Stack spacing={2}>
            <TextField
              fullWidth
              label="First Name"
              size="small"
              name="first_name"
              value={crc.first_name}
              onChange={handleChange}
              required
            />
            <TextField
              fullWidth
              label="Last Name"
              size="small"
              name="last_name"
              value={crc.last_name}
              onChange={handleChange}
              required
            />
            <TextField
              fullWidth
              label="Email"
              size="small"
              type="email"
              name="email"
              value={crc.email}
              onChange={handleChange}
              required
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={addCoordinatorMutation.isPending}
            startIcon={addCoordinatorMutation.isPending ? <CircularProgress size={16} /> : null}
          >
            {addCoordinatorMutation.isPending ? "Loading" : "Save & Invite"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddCrcModal;
